
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexDQs87ggEgMcheqwSTDlOIEAke5Lg_hU7BW8ScCxA5OUMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/index.vue?macro=true";
import { default as loginpKt8KE6_2i0mXaZ9CIhSA3CteQwm4TayFQpd0L6CXWUMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/login.vue?macro=true";
import { default as mgen7gGoMRqJ9igY17MXtInzcsHfe9Oibv10s6OC_45yOoV2kMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/mgen.vue?macro=true";
import { default as indexqCeLQQea2bVRzjkSMaYDC5GqlttPNScP1nRIjELFC_cMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/index.vue?macro=true";
import { default as notesfy9KnA6TVHIHTFGOKUB5o2XDvNU4Xd17mNquPYlYPogMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/notes.vue?macro=true";
import { default as indexBD8BeioIq1Hhow9Al0poa_5ruJ9i_boBi6PqNhHno3YMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentR35B0V5fLVUV3DuwCk84rw_45W6DfvLKaEGFCrsYG_LgEMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45site3VLTVkqkmQkQGYcAbX9W6p_45DuppOuLaSx7GLZNBwBBoMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/plan-du-site.vue?macro=true";
import { default as editfD_45TkaHdhcGRS885wqBwhBfEaCWPfw62lIbmbFPkNa8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/edit.vue?macro=true";
import { default as placesFyZbPkTzRjmEEDGjldP0TtI3ut_45IKAA1B0g5ywsRLksMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/places.vue?macro=true";
import { default as accessibiliteccoh1FhwEZpqYjNRr2kLRAnneAQJxET06rF_Y5J_wfIMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/accessibilite.vue?macro=true";
import { default as _91id_93pM3QXDUPZgDLjSg4T07dlKDRd_heDATMo40MmcyjlG8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/messages/[id].vue?macro=true";
import { default as notifications5lzK1GUsNAUfCAWbl_ZSFYVIrwenKuyVsEYzqbQa2dkMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/notifications.vue?macro=true";
import { default as indexrIHs_45Rk__45EKUdByKJZqu7sazdF8RQjAEmV7_E5JGQy0Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/index.vue?macro=true";
import { default as indexSxLeDvtHm_f2NbPgDk_vU7jp435PEKicLpQ5obL71rEMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/index.vue?macro=true";
import { default as _91slug_93xtQZmwgpabDHZ_Jey_hOmXPOK1kNEKPRmxDnkl8VKRQMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/villes/[slug].vue?macro=true";
import { default as index9uv0JLXHtYr_2YMDcpKH1dPgv_zPyA71qDXdlIURHJUMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/messages/index.vue?macro=true";
import { default as generiquegVpBFr2fjAyre3fdF6eR45qNQKjnTDsFHapdi0O3M1IMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93KjhCxOsIHBguoTQ1G1LV1PhLKOa3lStJd9qH3mYSx5wMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/reseaux/[slug].vue?macro=true";
import { default as missionssuIw6EjWvKcVksOFfCb8KFHiYzzLAI6TnA_45UKa1Uc0YMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/missions.vue?macro=true";
import { default as indexPi03_45aiOLyQThazwgz8_FGd457y2YEg2TLuGrhJlOyQMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/dashboard/index.vue?macro=true";
import { default as favorisCC6urkHP05EEbtlJhUhPaqOzIcOLD_45GQtwIwMTrRqJgMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93dnJrukYXByWGl4k3DjSM1AEc0oj6XYmxqPIeVq2l5ygMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/activites/[slug].vue?macro=true";
import { default as logsmGoh3wAmY8d9EwyYYkBImSEnzwI5zAeJkcxF9HyBsqkMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/other/logs.vue?macro=true";
import { default as ressources1tx4uepZIYLcjO92c14MlsL6SGZMI_45U_PDwv64Hh9GgMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesHfJ8R7RtmDaoKC6MkL3WASF_45kbMIpLbaaycTvEZ4r9UMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/mentions-legales.vue?macro=true";
import { default as missionsAgTCq3OV3XrF905FuvPcic2McO5T0IvGFikG_45H90nlUMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/missions.vue?macro=true";
import { default as settingskTo5BX2FsZ7k74oOHpsEYA8U8509ubuqe4CdWjLYDU0Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/settings.vue?macro=true";
import { default as tournee_45ete1fUzNfca_45Oe7In4ZGHeVRfgSTZdh3vrBaekyp4A273UMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/tournee-ete.vue?macro=true";
import { default as temoignagesXeb89DC1VHN8Z7zGqdS4s_t4l3_45OAI9j16FDf9PMSrsMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/temoignages.vue?macro=true";
import { default as indexydQ_IsI3AUUCRSH3wlFUeom4WngG4u0oJTX1MSTUYLUMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/index.vue?macro=true";
import { default as adminYmY2zR6HLOOMMEIFiJJiWiY6J_IPWg8o7bZXJ1M_45d_45AMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/maintenance/admin.vue?macro=true";
import { default as indexsG1sq6PR_45DCOaoYzxkJEmQvIbuQzkphRUUmAXTk_45Vk8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/maintenance/index.vue?macro=true";
import { default as indexesMq7MeeO_7X4mGLs4Bn1qyCAddIYYmmb_45IIVIb_454MUMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/territoires/index.vue?macro=true";
import { default as _91hash_93ET6L4PdeUgHKCheieUpFYRSnYPzXRKfmtUWXo8BESbAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursbPenBDKIilOOPlyhAorpNiyK6E7fTUkjzhp3K_RMd_45oMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93YERcXydjW6tsm1UC0L9uJtf78aPwsAvRcxlfgly5h18Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93qP6uaIJN20DRfr4LMrAPneOE_45LuzTOv8ceScLmqO4v8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/departements/[slug].vue?macro=true";
import { default as indexsnRWNVEjVhnrdhtQPrVRjDgB9lG_ioqxmIb4_ZMHDnkMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/organisations/index.vue?macro=true";
import { default as preferencesHXujiAkAIzsZ1l3Uo3PwFjIgTDz5rkkMt0WwuBbjL88Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/preferences.vue?macro=true";
import { default as organisationscBhW1vmbslNutA7q_45sl0MNSnO7_GfWqYkYBqF6eVYkoMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/organisations.vue?macro=true";
import { default as _91token_93MJcHDvao0snn_456EdFdQ_45RnK3Hkm_d7yXcYUEMjbRZz0Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/temoignages/[token].vue?macro=true";
import { default as postsrsHX7nwibO0n6FRFE_45WmvNoLBM5xndbKuOZEuAeC6LsMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/posts.vue?macro=true";
import { default as index3PLm4HAbYmpqw_45_bi48uGBDyamLc5bzFmSiXbM9qc4YMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/index.vue?macro=true";
import { default as add5Br0Mai80_tFYWHgHHigL46UQ_45GZjOMzujqxBDlGSKgMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_9377zC2tucf5iJKHkq4DEkqSrXvZRuTm3A0tbH_jS87_cMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/organisations/[slug].vue?macro=true";
import { default as indexvDDpW22BJwdHzi9BzWXhj4Woc99rOlxGUDd4AuCzi0YMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/password-reset/index.vue?macro=true";
import { default as participations3Z5XBvH0vpKaScrp7WU6TroO_PA5okzSaL7QHzOO9PYMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/participations.vue?macro=true";
import { default as emails66DzZYOwFFHlJ99RMSPYi4Ue3X50j4QMzeCDukFITYsMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/emails.vue?macro=true";
import { default as indexb1I4cmM9yzy2yl3gmPI7SZY74KLFHwTC1vKdJp_Me7QMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/alertes/index.vue?macro=true";
import { default as notificationspTGxPzv8ifAX2VAPVfw4NVUwFdKVfBZ1WbjoOvuqhFQMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/notifications.vue?macro=true";
import { default as indexo2J7xj0mi_YSYOdEv_45HVTSzdgnyCe6AW27Wg2MrnDBIMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiqueLkKn_c84CL4TkEtTxxbbDGLkD29feMmUjoO9Aq9DzP8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93URlUWHUK3vnekkXsw54z_45oiVJFp6zRp4Jicl_45vfgDvQMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/domaines-action/[slug].vue?macro=true";
import { default as indexlsH7i_Oo1ZKaB4jspkCwcULp5zd4O8vDG3I6mCj0XGwMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93XRxXDaBlQfrDJdLd2cq2HjSZPMwowixHhkdeRv7Th3EMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensemblejMUXfGKUAWk2XoGa7Q_45oN85Ku_45JeuFxG_mtbQaH_kJ8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationsbr_V8rSuijI9TpNT_45cWYRWrV8h84Bti6tTa9ntvX_45UkMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/other/invitations.vue?macro=true";
import { default as messagesrJ_SbvvxLwoW_45mVTyv7eZLkvo8H09Apa3kSwEI00hPEMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/messages.vue?macro=true";
import { default as placesI2JTeOV7va52gJeVJZV7TZa0z_45MK4suT_aAcv1H5cykMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/places.vue?macro=true";
import { default as addvHA4Q1rRvDPpBrQgDCmerBcHFqGDg9ymLnlBVT7mLQIMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexVEiBq2f5PM_45mjBvqCjQjYkjYK_45YVWGa1ITC0p2WHy_MMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexhrBbvkdeYnW5q0KoY_45dkiX9IT_45lTrxI4_Vfe_A9n0pIMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/missions-benevolat/index.vue?macro=true";
import { default as datesWstV9mjOhTgb22AADbIeJBTtg7VTgRGFFN1hE_459GHQkMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indextZouOCQQGLSnxwrnO9T6m_45Wych2eS3Nje_4595Hm2y9m8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxcy0IrG3vQHDOGa5TZpRUP96av3uhIQHYvOxmNY9VaKEMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titlek045_45bjQLFWOL3zMsu0JmP_459pgoK2YkgU8pw4kppDmcMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexiUzFscE9_45QhRj6hv_45kt9fc89COlmxLP__bL3_qQV_LAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/index.vue?macro=true";
import { default as missionsK_JxuSeNZ2WNtgAfOlzXO5nKeJ_45DNtJ2HuRr7iVut74Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/missions.vue?macro=true";
import { default as add0x5WwWUKz8En3LiWbIigUNTIQzT5QiAGXq9AxazPF_45AMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelueh5jBuEmbrnAKISI2d1WoVGirACfV3mO0c_45ytBh_P0Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexjnasPsx7v9FwwfT2tU92LSxOJCnUt0p4s5YLv2xz0HwMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/participations/index.vue?macro=true";
import { default as index_45HT42rGCJkqB_45MDn22schM34R4dUg_45wiP2U18sBUh0sMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexueh7KMWkMt_45En7nMpi9wVGKTBEf9QetkqwZv2_45Qgk3sMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/index.vue?macro=true";
import { default as addfMLrro_FDU_pXOSrN8nHKfVXJgReQLG5RtCYfMuXHgsMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addv4m3XVg_nL9uVL6KYPULhObtpjAaEVzDU3gNrw9KR3IMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addbOEAh0QG5_A8l02JJBNDg1a0R_45i_LSPB3lsD8wVbbVgMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexvfgliR4nY1A0Q_45afJNw2abHpgqxUilEdmGX_45xNyf0UkMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversions8tpEkFrgdu52a3fAk_4519EUdd9HSdvPWm0ZlYD_JXg2YMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/conversions.vue?macro=true";
import { default as editJBO6kxWj9zr05RJfaac7XF4fm9cN96HVtnKDW8QyJrMMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteM5lDxEm_45ImKkxVTOfphGQIoc_452M3sDLB5DanU2fTh8EMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/politique-de-confidentialite.vue?macro=true";
import { default as index87YSxWN384jLsA9ZqbeWw2IsX_45N1561aItVd59uM1HMMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as add1FKHms62rdMUs_45Lp43L73QY3qN5gr1M5AW4y7BTWkuUMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesodCtDjxzvBcWJYpmYIy1qoaw5mB76GXJDS8h8Vdw2R0Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editdJ_45k7cEkAqPSyXB3HDCCw5IMG37MNQkAnJw68QfR_45ncMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursaal4djnOE8kc3KSxdJ_45rAU1EFGqliP0xrwjVvICh39cMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexswwHBI2DISbB0W5pmsvRC6FKQ595M1a5avRprEK0SY4Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexMz2XJUfrwpd6_IR_45PAm0cJi1vJpBzll1f5Sz5C_45Fnk4Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as index0LyAFOBi_3CrCuOkbC97KiGrtRUfNPYygyyC91wms1UMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/index.vue?macro=true";
import { default as indexuIiwrvI4YytxkagEgyTBhjTXIKIPSDjEwiZiOMDo99MMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendre5r48bef6j2B5bhwxI2k3G3bL_45868WY7Q_zgJC_45dubs0Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexbjMndOfxV0JMxgFSD8coZGdY2uVpB29QGUqnUWeWB8YMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addwhDAbW8oeoldmT8iN22bY18BgPcLfcVFh3ODlE5_VTQMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexvBxaZbxniIMpssNgPejgnSqj1SQZ2ltCiD7UzOqdvAkMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editQQVyyZcrlVx8bSJYcLQ5U7z0LihU5_Y5DJgOrQt944gMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93hBBBupk0ZuZj78USl_45VFjx9fjljdUz7JiftwRU7Oe7MMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planetelFYm_hQMOJgaehzTxp0xpkGkgzdXwFBKiKqU_454wIJxYMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexm0qQvMQYBh3l0HEppk29tIQYaQ8lU42gqdFiRhg4IAMMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsmraWRsyHAVn7yxfydyqA2XS7LFPpdWrA6zGzwKdDDUsMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/participations.vue?macro=true";
import { default as index6o__ZUN_zTXH6VNrLmNdNjWYLl41Ou_45MFt1RgLaP0KcMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsycEMmonYkZPaMNM5NzFJGXopf11h6Fyc4N5hs39uTkcMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/referents/activity-logs.vue?macro=true";
import { default as editVvkwgulVHjBziaEh6mJRf_45yEgUkoBMa7_45w4KcvUJo_45EMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexhfXkrca_TnEdgWws0mXVev_45LPRDqi8vZOgvnVgFuCvEMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsSq_loIJnCZn_tXdId9Hu6kM785ik8W4YtCHLOgz_T9oMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsables5z00hoM3jhN1_45LqWfuyBlTP8BeppZixlpHMplMvxDJQMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editwvBrED_YCinHfnwV8R2jTPb2tmyUdhWKrpftEjOBfBcMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexiHhpnkYdQpHW6KDCqGrgHfzckuZmKmhTJC2FG5mCQk8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexkU0bhzG4Z1qRdyZu5PnQ8_3zv_CwMJiY9hxAOhJvvawMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesndZm6G4Y_45ZNMDeb0_p66TieV84KHPeRXo6Hv48E5eKIMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as edit41b_w3eJSfoQrI3qb5_45h_45PU4XDsmuuYEuARy_SARc2IMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profileK6M0tekPyOXGue0k7OdrwoALTD7T3wb2_KRmlilrMasMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnement8jPxI_pqBD95zne6vzitpDjag2y_6iB0QYbaxZqcf3kMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsog88ahYg0hddrdHW33CxNzuR5_Lr7HAj3H052_45jarg8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editNmyUAgZTAVfXUbW9Rf5CHUngl6PkHFTGhe_45tLrUfGu0Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as adddH1jrgSYRXYyrFmyfDQLdn6rL9_NZGRiCM6FhaHKLeAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisation9W6fTHXStpCLkVwZ4dTEPwZ5egNvzXVthxkXImqmNR0Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexus0DLDHE2sXmPaishaHUdM_45ci3piHTKK9JS7l8_KMUIMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as edit7hSyDhZiBYTPfLBLsbx4jmtBVCZA_qjtT_45S0QBmdVdYMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsIT0n_N3A_45jmqXtnI1fXyuX0tPC5TPklzsKXQGhz3k00Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsS8ftCDn_O2PnD9Dgc59w_45bvgInaXGT95p6Nh8_KwoRkMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesM_45EGYe_454JfeVJ9JATh2i_45QZ_454P7rIH_45dUdNu__hVTlwMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexing5e4vT6fdaqu2OyaIVjv5gnM7SBYYkv3_45FbOoMcMU8BMMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as index4Qq6sQy75pL_45EVuXXEGKgmAZUHkGnQY_45a9GUO2FJavwMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editnzyhm5ELH9rUobeBYJJl1Kfc53NTJeBGgAi6DKj_iCYMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexaDj9wguv06p8mET_mn0oAP4izo5BDq8jACsBBEDdRq8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profilexQ9yQI4x8ImiH_YGbogs78PGlTBSXzPf9hgvhiRoMo4Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexBq91Rb7wvK3REniOapuODI_juIRdMw3ju5RjZoKD4E4Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editdsNM0MzLVVonFmbw8O0gNLQj3uGjPR7ffKCerZ1ozpAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addTgCaN_459GmehA155iIG5FXatjE_45JxcY0LfrKaUTQo030Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competences6DZyk0axvl4RIKBU_45_455fnvwtZ_KKY5cirJY8rk2ttNoMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesYy5ZhHCsMjAJx_tip_QhkN9u8sIjyPpPMRKPIxKb29cMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45userstr8Nu1piDw0sCxq0MJL4jff7vb9AKwmth0cg1_45SdH4sMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresiryYTJIkLFHmEsduaRXL17OiziAH0MM6MDTph8hNX0QMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablesQ06kZeQh2AyvtC46dF2_45XnBti_E6ivmQq_45TW5qADEyAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationHG7BXo1wJejm5NBHXIrWGgBIoLL4lBj_45ag88ffhc6kQMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedp1q558okhOIs2AJkIz1wXG8TG3fY1McK2CyiYsAtvdEMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemstmrsbBscGpsPi_45FbDnQOAu1W1DpQcdaaHnqpWbRvK8sMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45roleQ5YbN_0njIHMuWsNkpHnIom3aft3QzMobH5WIMCVvKgMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisations2bIQ1t7UN8Gdm_w4WJP9o4DVwohBEyc2dJXp4YsFCeAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editK67gyjMo_45_7406_45VWIjT6D1FHC95gSkdWvJSSgcDlMAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibiliteshbVs3C9cw9m_45UZIfQ_45m30nWhg5q2dWwgDZ0h9B3S59MMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkhygm9BZoiDyVK_45kATSFUNbQawpINj11TQ8Oag6b2NhYMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexXywplIB_45vorHzqzO1MnDUxcKctPSpk4HjsGlmnUTaAgMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectiviteZglPkyHmhXJFeADFWRASm9lwDRsi_45UwF9M3dLdAtmrEMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationHu9iob_ZyhJE5JOVVKWzYeq2ZvDRHM_ZsDQPu9gL5TAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsIZGn9P2vIHMVF5oa8hQVmsu79saIR7POw1Kc8QfZFCQMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantHvzIVsVW9u3D2K2EAcbSy91K4533817h6baThrd_45V3gMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantVCX2wkzsF5EgpRWgS_455EkWwahKqax34AArBN9dzNMA4Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexhDuCw92wXBLDjpdWN6nNt33pS7i_45Qy0nqbllVQYe4NoMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimees_8X9j6DjL_LQ2o9pDge6AGuXJhnqrc4iFmxQJXbqteYMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerX7YvVmdhNLUNNtAAxB47_45l8xCBJicGCIYKtqRKnvncsMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesrucAWyBQGpphq0ULKu_45VS8q_OpyHi6KTpx4eCy1b8_45kMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesVhAknNp2Jivu6esJ52l59QZ3FLDRo4FZrwrqBnWJtD4Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsujt2OVQHxams3XHxN4AGuxKoSlDA0XicD7Sgp7on6aMMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatede3awNmG5cbIkruPfT9tTgDJwJXWtkyZ_45F2gG_SPp9mMMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectBiJ5WWPaqN42jlPq3QQvF7UCOkpCaBwUI4RRqhqjlq8Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45valider_NHI0KeKw0rPv_45PRpk7RBOl1YFuWQg6ROz_45mt5WHKlAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnemento7i4pwRp_uAIcfe50qJ_KUtMfEH_VYnI8WWJJ2V0X7YMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationUizJ4nAW1fCYFDczjQCE5cU865bBPO4Diqf0OswneSMMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationSyTIdYwlFBt6sJu_454bSufZNMYsA2cIIuiMKzPSr3JasMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerpYS2846FaQIKf3XHjzHpfYOUdbpmkB4945KmPNM2KP4Meta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesU2x7Zd42PSTpKKWOjqBQQ2Dx8ybjkJXXhq5tQqEM3nAMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs } from "/build/86706377-e004-4bef-803f-d83a2ab5cce0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginpKt8KE6_2i0mXaZ9CIhSA3CteQwm4TayFQpd0L6CXWUMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgen7gGoMRqJ9igY17MXtInzcsHfe9Oibv10s6OC_45yOoV2kMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexqCeLQQea2bVRzjkSMaYDC5GqlttPNScP1nRIjELFC_cMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesfy9KnA6TVHIHTFGOKUB5o2XDvNU4Xd17mNquPYlYPogMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexBD8BeioIq1Hhow9Al0poa_5ruJ9i_boBi6PqNhHno3YMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editfD_45TkaHdhcGRS885wqBwhBfEaCWPfw62lIbmbFPkNa8Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesFyZbPkTzRjmEEDGjldP0TtI3ut_45IKAA1B0g5ywsRLksMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93pM3QXDUPZgDLjSg4T07dlKDRd_heDATMo40MmcyjlG8Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notifications5lzK1GUsNAUfCAWbl_ZSFYVIrwenKuyVsEYzqbQa2dkMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexrIHs_45Rk__45EKUdByKJZqu7sazdF8RQjAEmV7_E5JGQy0Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexSxLeDvtHm_f2NbPgDk_vU7jp435PEKicLpQ5obL71rEMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: index9uv0JLXHtYr_2YMDcpKH1dPgv_zPyA71qDXdlIURHJUMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiquegVpBFr2fjAyre3fdF6eR45qNQKjnTDsFHapdi0O3M1IMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93KjhCxOsIHBguoTQ1G1LV1PhLKOa3lStJd9qH3mYSx5wMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionssuIw6EjWvKcVksOFfCb8KFHiYzzLAI6TnA_45UKa1Uc0YMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexPi03_45aiOLyQThazwgz8_FGd457y2YEg2TLuGrhJlOyQMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisCC6urkHP05EEbtlJhUhPaqOzIcOLD_45GQtwIwMTrRqJgMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsmGoh3wAmY8d9EwyYYkBImSEnzwI5zAeJkcxF9HyBsqkMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsAgTCq3OV3XrF905FuvPcic2McO5T0IvGFikG_45H90nlUMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingskTo5BX2FsZ7k74oOHpsEYA8U8509ubuqe4CdWjLYDU0Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/settings.vue")
  },
  {
    name: "quiz-tournee-ete",
    path: "/quiz/tournee-ete",
    meta: tournee_45ete1fUzNfca_45Oe7In4ZGHeVRfgSTZdh3vrBaekyp4A273UMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/tournee-ete.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexydQ_IsI3AUUCRSH3wlFUeom4WngG4u0oJTX1MSTUYLUMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminYmY2zR6HLOOMMEIFiJJiWiY6J_IPWg8o7bZXJ1M_45d_45AMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexsG1sq6PR_45DCOaoYzxkJEmQvIbuQzkphRUUmAXTk_45Vk8Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93ET6L4PdeUgHKCheieUpFYRSnYPzXRKfmtUWXo8BESbAMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursbPenBDKIilOOPlyhAorpNiyK6E7fTUkjzhp3K_RMd_45oMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesHXujiAkAIzsZ1l3Uo3PwFjIgTDz5rkkMt0WwuBbjL88Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationscBhW1vmbslNutA7q_45sl0MNSnO7_GfWqYkYBqF6eVYkoMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93MJcHDvao0snn_456EdFdQ_45RnK3Hkm_d7yXcYUEMjbRZz0Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsrsHX7nwibO0n6FRFE_45WmvNoLBM5xndbKuOZEuAeC6LsMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: index3PLm4HAbYmpqw_45_bi48uGBDyamLc5bzFmSiXbM9qc4YMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: add5Br0Mai80_tFYWHgHHigL46UQ_45GZjOMzujqxBDlGSKgMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_9377zC2tucf5iJKHkq4DEkqSrXvZRuTm3A0tbH_jS87_cMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexvDDpW22BJwdHzi9BzWXhj4Woc99rOlxGUDd4AuCzi0YMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participations3Z5XBvH0vpKaScrp7WU6TroO_PA5okzSaL7QHzOO9PYMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emails66DzZYOwFFHlJ99RMSPYi4Ue3X50j4QMzeCDukFITYsMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexb1I4cmM9yzy2yl3gmPI7SZY74KLFHwTC1vKdJp_Me7QMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationspTGxPzv8ifAX2VAPVfw4NVUwFdKVfBZ1WbjoOvuqhFQMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexo2J7xj0mi_YSYOdEv_45HVTSzdgnyCe6AW27Wg2MrnDBIMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexlsH7i_Oo1ZKaB4jspkCwcULp5zd4O8vDG3I6mCj0XGwMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93XRxXDaBlQfrDJdLd2cq2HjSZPMwowixHhkdeRv7Th3EMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensemblejMUXfGKUAWk2XoGa7Q_45oN85Ku_45JeuFxG_mtbQaH_kJ8Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationsbr_V8rSuijI9TpNT_45cWYRWrV8h84Bti6tTa9ntvX_45UkMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesrJ_SbvvxLwoW_45mVTyv7eZLkvo8H09Apa3kSwEI00hPEMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesI2JTeOV7va52gJeVJZV7TZa0z_45MK4suT_aAcv1H5cykMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addvHA4Q1rRvDPpBrQgDCmerBcHFqGDg9ymLnlBVT7mLQIMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexVEiBq2f5PM_45mjBvqCjQjYkjYK_45YVWGa1ITC0p2WHy_MMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexhrBbvkdeYnW5q0KoY_45dkiX9IT_45lTrxI4_Vfe_A9n0pIMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesWstV9mjOhTgb22AADbIeJBTtg7VTgRGFFN1hE_459GHQkMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indextZouOCQQGLSnxwrnO9T6m_45Wych2eS3Nje_4595Hm2y9m8Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxcy0IrG3vQHDOGa5TZpRUP96av3uhIQHYvOxmNY9VaKEMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titlek045_45bjQLFWOL3zMsu0JmP_459pgoK2YkgU8pw4kppDmcMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexiUzFscE9_45QhRj6hv_45kt9fc89COlmxLP__bL3_qQV_LAMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsK_JxuSeNZ2WNtgAfOlzXO5nKeJ_45DNtJ2HuRr7iVut74Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: add0x5WwWUKz8En3LiWbIigUNTIQzT5QiAGXq9AxazPF_45AMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelueh5jBuEmbrnAKISI2d1WoVGirACfV3mO0c_45ytBh_P0Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexjnasPsx7v9FwwfT2tU92LSxOJCnUt0p4s5YLv2xz0HwMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: index_45HT42rGCJkqB_45MDn22schM34R4dUg_45wiP2U18sBUh0sMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexueh7KMWkMt_45En7nMpi9wVGKTBEf9QetkqwZv2_45Qgk3sMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addfMLrro_FDU_pXOSrN8nHKfVXJgReQLG5RtCYfMuXHgsMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addv4m3XVg_nL9uVL6KYPULhObtpjAaEVzDU3gNrw9KR3IMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addbOEAh0QG5_A8l02JJBNDg1a0R_45i_LSPB3lsD8wVbbVgMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexvfgliR4nY1A0Q_45afJNw2abHpgqxUilEdmGX_45xNyf0UkMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversions8tpEkFrgdu52a3fAk_4519EUdd9HSdvPWm0ZlYD_JXg2YMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editJBO6kxWj9zr05RJfaac7XF4fm9cN96HVtnKDW8QyJrMMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: index87YSxWN384jLsA9ZqbeWw2IsX_45N1561aItVd59uM1HMMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: add1FKHms62rdMUs_45Lp43L73QY3qN5gr1M5AW4y7BTWkuUMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesodCtDjxzvBcWJYpmYIy1qoaw5mB76GXJDS8h8Vdw2R0Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editdJ_45k7cEkAqPSyXB3HDCCw5IMG37MNQkAnJw68QfR_45ncMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursaal4djnOE8kc3KSxdJ_45rAU1EFGqliP0xrwjVvICh39cMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexswwHBI2DISbB0W5pmsvRC6FKQ595M1a5avRprEK0SY4Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexMz2XJUfrwpd6_IR_45PAm0cJi1vJpBzll1f5Sz5C_45Fnk4Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendre5r48bef6j2B5bhwxI2k3G3bL_45868WY7Q_zgJC_45dubs0Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexbjMndOfxV0JMxgFSD8coZGdY2uVpB29QGUqnUWeWB8YMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addwhDAbW8oeoldmT8iN22bY18BgPcLfcVFh3ODlE5_VTQMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexvBxaZbxniIMpssNgPejgnSqj1SQZ2ltCiD7UzOqdvAkMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editQQVyyZcrlVx8bSJYcLQ5U7z0LihU5_Y5DJgOrQt944gMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planetelFYm_hQMOJgaehzTxp0xpkGkgzdXwFBKiKqU_454wIJxYMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexm0qQvMQYBh3l0HEppk29tIQYaQ8lU42gqdFiRhg4IAMMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsmraWRsyHAVn7yxfydyqA2XS7LFPpdWrA6zGzwKdDDUsMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsycEMmonYkZPaMNM5NzFJGXopf11h6Fyc4N5hs39uTkcMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editVvkwgulVHjBziaEh6mJRf_45yEgUkoBMa7_45w4KcvUJo_45EMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexhfXkrca_TnEdgWws0mXVev_45LPRDqi8vZOgvnVgFuCvEMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsSq_loIJnCZn_tXdId9Hu6kM785ik8W4YtCHLOgz_T9oMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsables5z00hoM3jhN1_45LqWfuyBlTP8BeppZixlpHMplMvxDJQMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editwvBrED_YCinHfnwV8R2jTPb2tmyUdhWKrpftEjOBfBcMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexiHhpnkYdQpHW6KDCqGrgHfzckuZmKmhTJC2FG5mCQk8Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexkU0bhzG4Z1qRdyZu5PnQ8_3zv_CwMJiY9hxAOhJvvawMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesndZm6G4Y_45ZNMDeb0_p66TieV84KHPeRXo6Hv48E5eKIMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: edit41b_w3eJSfoQrI3qb5_45h_45PU4XDsmuuYEuARy_SARc2IMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profileK6M0tekPyOXGue0k7OdrwoALTD7T3wb2_KRmlilrMasMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsog88ahYg0hddrdHW33CxNzuR5_Lr7HAj3H052_45jarg8Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editNmyUAgZTAVfXUbW9Rf5CHUngl6PkHFTGhe_45tLrUfGu0Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: adddH1jrgSYRXYyrFmyfDQLdn6rL9_NZGRiCM6FhaHKLeAMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexus0DLDHE2sXmPaishaHUdM_45ci3piHTKK9JS7l8_KMUIMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: edit7hSyDhZiBYTPfLBLsbx4jmtBVCZA_qjtT_45S0QBmdVdYMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsIT0n_N3A_45jmqXtnI1fXyuX0tPC5TPklzsKXQGhz3k00Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsS8ftCDn_O2PnD9Dgc59w_45bvgInaXGT95p6Nh8_KwoRkMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexing5e4vT6fdaqu2OyaIVjv5gnM7SBYYkv3_45FbOoMcMU8BMMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: index4Qq6sQy75pL_45EVuXXEGKgmAZUHkGnQY_45a9GUO2FJavwMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editnzyhm5ELH9rUobeBYJJl1Kfc53NTJeBGgAi6DKj_iCYMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexaDj9wguv06p8mET_mn0oAP4izo5BDq8jACsBBEDdRq8Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profilexQ9yQI4x8ImiH_YGbogs78PGlTBSXzPf9hgvhiRoMo4Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexBq91Rb7wvK3REniOapuODI_juIRdMw3ju5RjZoKD4E4Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editdsNM0MzLVVonFmbw8O0gNLQj3uGjPR7ffKCerZ1ozpAMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addTgCaN_459GmehA155iIG5FXatjE_45JxcY0LfrKaUTQo030Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competences6DZyk0axvl4RIKBU_45_455fnvwtZ_KKY5cirJY8rk2ttNoMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesYy5ZhHCsMjAJx_tip_QhkN9u8sIjyPpPMRKPIxKb29cMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45userstr8Nu1piDw0sCxq0MJL4jff7vb9AKwmth0cg1_45SdH4sMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresiryYTJIkLFHmEsduaRXL17OiziAH0MM6MDTph8hNX0QMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationHG7BXo1wJejm5NBHXIrWGgBIoLL4lBj_45ag88ffhc6kQMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedp1q558okhOIs2AJkIz1wXG8TG3fY1McK2CyiYsAtvdEMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemstmrsbBscGpsPi_45FbDnQOAu1W1DpQcdaaHnqpWbRvK8sMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45roleQ5YbN_0njIHMuWsNkpHnIom3aft3QzMobH5WIMCVvKgMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisations2bIQ1t7UN8Gdm_w4WJP9o4DVwohBEyc2dJXp4YsFCeAMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editK67gyjMo_45_7406_45VWIjT6D1FHC95gSkdWvJSSgcDlMAMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibiliteshbVs3C9cw9m_45UZIfQ_45m30nWhg5q2dWwgDZ0h9B3S59MMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkhygm9BZoiDyVK_45kATSFUNbQawpINj11TQ8Oag6b2NhYMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexXywplIB_45vorHzqzO1MnDUxcKctPSpk4HjsGlmnUTaAgMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectiviteZglPkyHmhXJFeADFWRASm9lwDRsi_45UwF9M3dLdAtmrEMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationHu9iob_ZyhJE5JOVVKWzYeq2ZvDRHM_ZsDQPu9gL5TAMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsIZGn9P2vIHMVF5oa8hQVmsu79saIR7POw1Kc8QfZFCQMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantHvzIVsVW9u3D2K2EAcbSy91K4533817h6baThrd_45V3gMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantVCX2wkzsF5EgpRWgS_455EkWwahKqax34AArBN9dzNMA4Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexhDuCw92wXBLDjpdWN6nNt33pS7i_45Qy0nqbllVQYe4NoMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimees_8X9j6DjL_LQ2o9pDge6AGuXJhnqrc4iFmxQJXbqteYMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerX7YvVmdhNLUNNtAAxB47_45l8xCBJicGCIYKtqRKnvncsMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesrucAWyBQGpphq0ULKu_45VS8q_OpyHi6KTpx4eCy1b8_45kMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesVhAknNp2Jivu6esJ52l59QZ3FLDRo4FZrwrqBnWJtD4Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsujt2OVQHxams3XHxN4AGuxKoSlDA0XicD7Sgp7on6aMMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatede3awNmG5cbIkruPfT9tTgDJwJXWtkyZ_45F2gG_SPp9mMMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45valider_NHI0KeKw0rPv_45PRpk7RBOl1YFuWQg6ROz_45mt5WHKlAMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationUizJ4nAW1fCYFDczjQCE5cU865bBPO4Diqf0OswneSMMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationSyTIdYwlFBt6sJu_454bSufZNMYsA2cIIuiMKzPSr3JasMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerpYS2846FaQIKf3XHjzHpfYOUdbpmkB4945KmPNM2KP4Meta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesU2x7Zd42PSTpKKWOjqBQQ2Dx8ybjkJXXhq5tQqEM3nAMeta || {},
    component: () => import("/build/86706377-e004-4bef-803f-d83a2ab5cce0/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/user/settings",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/inscription/organisation",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/statistiques",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  },
  {
    name: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqsMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubKHiyN9_45ydDppQkw4CC4_45Ff8aGnG0ymu_45lFQXcfh_mqs
  }
]